export function validateCNPJ(cnpj: string, allowAlphanumeric = true): boolean {
	const sanitizeRegex = allowAlphanumeric ? /[^A-Za-z0-9]/g : /\D/g;
	const cleanCnpj = (cnpj ?? '').replace(sanitizeRegex, '').toUpperCase();

	if (cleanCnpj.length !== 14 || /^(.)\1{13}$/.test(cleanCnpj)) {
		return false;
	}

	const formatRegex = allowAlphanumeric ? /^[A-Z0-9]{12}\d{2}$/ : /^\d{14}$/;
	if (!formatRegex.test(cleanCnpj)) {
		return false;
	}

	const values = cleanCnpj.split('').map(char => char.charCodeAt(0) - 48);

	const weights = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
	const sum = values.slice(0, 12).reduce((acc, value, index) => acc + value * weights[index], 0);
	const mod = sum % 11;
	const digit13 = mod < 2 ? 0 : 11 - mod;

	if (values[12] !== digit13) {
		return false;
	}

	const newWeights = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
	const newSum = values
		.slice(0, 13)
		.reduce((acc, value, index) => acc + value * newWeights[index], 0);
	const newMod = newSum % 11;
	const digit14 = newMod < 2 ? 0 : 11 - newMod;

	return values[13] === digit14;
}
